import axios from 'axios';

import { authHeader } from '@H';
import { authService } from '@S';

export default {
  getBankAccountList: () =>
    axios({
      method: 'GET',
      headers: authHeader(),
      url: `${process.env.API_URL}/utils/account-types/`,
    }),
  getBankList: () =>
    axios({
      method: 'GET',
      headers: authHeader(),
      url: `${process.env.API_URL}/utils/banks/`,
    }),
  getShiftList: () =>
    axios({
      method: 'GET',
      headers: authHeader(),
      url: `${process.env.API_URL}/bunk/shifts/view-shifts/`,
    }),
  getProductList: () =>
    axios({
      method: 'GET',
      headers: authHeader(),
      url: `${process.env.API_URL}/lubes/bunk/category/`,
    }),
  getWalletList: () =>
    axios({
      method: 'GET',
      headers: authHeader(),
      url: `${process.env.API_URL}/utils/wallets/`,
    }),
  getSwipeList: () =>
    axios({
      method: 'GET',
      headers: authHeader(),
      url: `${process.env.API_URL}/utils/swipe-machines/`,
    }),

  getFuelList: (omc_id) =>
    axios({
      method: 'GET',
      headers: authHeader(),
      url: `${process.env.API_URL}/bunk/omc/product/${omc_id}`,
    }),
  getOMCList: () =>
    axios({
      method: 'GET',
      headers: authHeader(),
      url: `${process.env.API_URL}/bunk/omc/omc-list`,
    }),
};
